import { useQuery } from '@tanstack/react-query';

import { fetchData } from 'src/app/queries';

import { marketingCampaignsQueryKey } from './get-campaigns';

import type {
  RecipientSegment,
  SavedMarketingEmailData,
  SavedMarketingPushData,
  SavedMarketingSMSData,
  Tag,
} from './get-campaigns';

export const GET_WORKFLOW_CAMPAIGNS = 'api/marketing-campaign/get-all-workflow-campaigns';

export type SavedWorkflowCampaign = {
  CampaignName: string;
  CampaignStatusId: number;
  DelayInMinutes: number | null;
  DelayUnitId: number | null;
  EmailConfig: [SavedMarketingEmailData];
  EventTypeId: number | null;
  ExternalGuid: string;
  LastModifiedDateUTC: string | null;
  LastRuntimeDateUtc: string | null;
  LspId: number;
  MarketingCampaignId: number;
  PushConfig: [SavedMarketingPushData];
  RecipientSegmentIds: number[];
  RecipientSegments: RecipientSegment[];
  ScheduleSendForUtc: string | null;
  SendToAllCustomers: boolean;
  SMSConfig: [SavedMarketingSMSData];
  TagIds: number[];
  Tags: Tag[];
  TimeOfDayToSend: string | null;
};

export type GetWorkflowCampaignsResult = SavedWorkflowCampaign[];

export const workflowCampaignsQueryKey = [...marketingCampaignsQueryKey, 'workflows'];

export function useGetWorkflowCampaignsQuery() {
  return useQuery({
    queryKey: workflowCampaignsQueryKey,
    queryFn: () => fetchData<GetWorkflowCampaignsResult>(GET_WORKFLOW_CAMPAIGNS),
    staleTime: Infinity,
  });
}
